import { isEqual } from 'lodash/fp';

import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { AccountAction } from 'dashboard/models/account-action';
import { TriggerAccount } from 'dashboard/models/trigger';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import {
  AccountActionsActions,
  AccountActionsActionType,
  AccountActionsFilterParams,
} from 'dashboard/redux/actions/account-actions';

export const initialAccountActionsFilterState: AccountActionsFilterParams = {
  status: [],
  omni: undefined,
};

export interface AccountActionsState {
  accountActions: AccountAction[];
  actionWorkflowVersions: WorkflowVersion[];
  triggers: TriggerAccount[];
  filters: AccountActionsFilterParams;
  sortParams: SortParams;
}

const initialAccountActionsState: AccountActionsState = {
  accountActions: [],
  actionWorkflowVersions: [],
  triggers: [],
  filters: initialAccountActionsFilterState,
  sortParams: {
    sort: 'updated_at',
    shouldSortDescending: true,
  },
};

export default (
  state: AccountActionsState = initialAccountActionsState,
  action: AccountActionsActions,
) => {
  switch (action.type) {
    case AccountActionsActionType.SetAccountActions: {
      return {
        ...state,
        accountActions: action.payload?.accountActions,
      };
    }

    case AccountActionsActionType.SetTriggers: {
      return {
        ...state,
        triggers: action.payload?.triggers,
      };
    }

    case AccountActionsActionType.SetActionWorkflowVersions: {
      return {
        ...state,
        actionWorkflowVersions: action.payload?.actionWorkflowVersions,
      };
    }

    case AccountActionsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload?.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case AccountActionsActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...action.payload?.sortParams,
        },
      };
    }

    default:
      return state;
  }
};
